import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { AlertCircle, RefreshCw, LogIn } from 'lucide-react';

const TokenRecovery = ({ onRetry, onLogin }) => {
  const [isRetrying, setIsRetrying] = useState(false);
  const { logout } = useAuth();

  const handleRetry = async () => {
    setIsRetrying(true);
    try {
      // Wait a moment then retry
      await new Promise(resolve => setTimeout(resolve, 1000));
      onRetry();
    } finally {
      setIsRetrying(false);
    }
  };

  const handleLogin = () => {
    logout();
    onLogin();
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-6">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
            <AlertCircle className="h-6 w-6 text-red-600" />
          </div>
          
          <h2 className="text-xl font-semibold text-gray-900 mb-2">
            Session Issue Detected
          </h2>
          
          <p className="text-gray-600 mb-6">
            We're having trouble verifying your login session. This can happen when:
          </p>
          
          <ul className="text-left text-sm text-gray-600 mb-6 space-y-2">
            <li>• Your session has expired</li>
            <li>• The server was restarted</li>
            <li>• There's a temporary connection issue</li>
          </ul>
          
          <div className="space-y-3">
            <button
              onClick={handleRetry}
              disabled={isRetrying}
              className="w-full flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50"
            >
              {isRetrying ? (
                <>
                  <RefreshCw className="animate-spin h-4 w-4 mr-2" />
                  Retrying...
                </>
              ) : (
                <>
                  <RefreshCw className="h-4 w-4 mr-2" />
                  Try Again
                </>
              )}
            </button>
            
            <button
              onClick={handleLogin}
              className="w-full flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              <LogIn className="h-4 w-4 mr-2" />
              Log In Again
            </button>
          </div>
          
          <p className="text-xs text-gray-500 mt-4">
            If this problem persists, please contact support.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TokenRecovery;

